export enum MeetRemainingTimeDomainEvents {
    timerFinished = 'timer_finished',
    openedRemainingTimeModal = 'opened_remaining_time_modal',
    closedRemainingTimeModal = 'closed_remaining_time_modal',
}